(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ravooy-discount-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-rvy-discount-popup-root]');
  if (!root || (window.Shopify && window.Shopify.designMode)) return;
  const dialog = root.querySelector('dialog');
  if (!dialog || !dialog.showModal) return;
  try { if (sessionStorage.getItem('rvy-discount-popup-seen') === '1') return; } catch (error) {}
  let shown = false;
  const show = () => {
    if (shown || document.hidden) return;
    shown = true;
    dialog.showModal();
    try { sessionStorage.setItem('rvy-discount-popup-seen', '1'); } catch (error) {}
  };
  window.setTimeout(show, 2400);
  document.addEventListener('visibilitychange', show);
  root.querySelector('[data-rvy-discount-close]').addEventListener('click', () => dialog.close());
  const copy = root.querySelector('[data-rvy-discount-copy]');
  copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText('RAVOOY10');
      copy.textContent = copy.dataset.copiedLabel;
    } catch (error) {}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
